import React, { useState, useEffect } from 'react';
import ReactGA from 'react-ga4';

export default function CookieConsent({ isDarkMode }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if they have already made a choice
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      setIsVisible(true);
    } else if (consent === 'accepted') {
      // Initialize silently if they already accepted in the past
      ReactGA.initialize('G-XMJ9FG2FP3'); 
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setIsVisible(false);
    // Initialize immediately when they click the button
    ReactGA.initialize('G-XMJ9FG2FP3'); 
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div style={{ position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)', width: '90%', maxWidth: '600px', backgroundColor: isDarkMode ? '#1e293b' : '#ffffff', border: `2px solid ${isDarkMode ? '#38bdf8' : '#0369a1'}`, borderRadius: '12px', padding: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)', zIndex: 99999, display: 'flex', flexDirection: 'column', gap: '15px' }}>
      <div>
        <h3 style={{ margin: '0 0 8px 0', fontSize: '16px', color: isDarkMode ? '#f8fafc' : '#0f172a' }}>🍪 We value your privacy</h3>
        <p style={{ margin: 0, fontSize: '13px', color: isDarkMode ? '#94a3b8' : '#475569', lineHeight: '1.5' }}>
          We use strictly necessary cookies to keep you logged in securely. We would also like to use analytics cookies to understand how you use My Typing Coach so we can improve it. 
          <a href="/privacy.html" target="_blank" rel="noreferrer" style={{ color: '#0369a1', marginLeft: '5px', textDecoration: 'none', fontWeight: 'bold' }}>Read our Privacy Policy.</a>
        </p>
      </div>
      <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button onClick={handleDecline} style={{ padding: '8px 16px', backgroundColor: 'transparent', color: isDarkMode ? '#94a3b8' : '#64748b', border: `1px solid ${isDarkMode ? '#334155' : '#e2e8f0'}`, borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
          Decline Optional
        </button>
        <button onClick={handleAccept} style={{ padding: '8px 16px', backgroundColor: '#0369a1', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}>
          Accept All
        </button>
      </div>
    </div>
  );
}